<form>
  @if (page() === -3) {
    <app-instruction></app-instruction>

    <div>

      <mat-expansion-panel class="imprint-expansion-panel" [(expanded)]="eulaExpanded">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="header-imprint">Nutzungs&shy;bedingungen</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (eulaExpanded()) {
          <app-imprint [hideTitle]="true" />
        }
      </mat-expansion-panel>

      <div>
        <label>
          <input type="checkbox"
            [checked]="profileForm.readInstructions().value()"
            (change)="toggleAcceptReadInstructions()"
            class="checkbox-accept-terms">
            Ich habe die Hinweise gelesen und verstanden*
        </label>
      </div>

      <label>
        <input type="checkbox"
          [checked]="profileForm.acceptTerms().value()"
          (change)="toggleAcceptTerms()"
          class="checkbox-accept-terms">
          Ich akzeptiere die Nutzungs&shy;bedingungen*
      </label>
    </div>
  }

  @if (page() === -2) {
    <app-tutorial></app-tutorial>
  }

@if (page() === -1) {
  <div
    class="onboarding-container">
    <h2 class="onboarding-title">{{'checkin_title' | translate}}</h2>
    <p class="onboarding-text">{{'checkin_text_1' | translate}}</p>
    <p class="onboarding-text">{{'checkin_text_2' | translate}}</p>
    <p class="onboarding-text">{{'checkin_text_3' | translate}}</p>
  </div>
}

@if (page() === 0) {
    <h2 class="onboarding-title">Informationen zum Kind</h2>


    <h2 class="title-age">{{'age' | translate}}</h2>
    <p class="onboarding-text">{{'age_text' | translate}}</p>
    <label>
      <input type="radio" value="10-14" [formField]="profileForm.ageGroup" />
      10 - 14 Jahre
    </label>
    <label>
      <input type="radio" value="15-17" [formField]="profileForm.ageGroup" />
      15 - 17 Jahre
    </label>

    <h2>Wähle einen Avatar</h2>
    <div class="container-avatars">
      @for (avatar of availableAvatars; track $index) {
        <label class="label-avatar">
          <input type="radio" [value]="avatar" [formField]="profileForm.avatar" class="input-avatar" />
          <img [src]="`../../../../assets/icons/${avatar}.svg`" alt="avatar">
        </label>
      }
    </div>

    <h2>Vorname (optional)</h2>
    <input type="text" [formField]="profileForm.name" class="input-text" />
  }

    @if (page() > 0) {
      <div class="container-situation">
        <h2 class="title-situation">{{'which_situation' | translate}} @if(page() <= pageNumber()) {{{page()}}/{{pageNumber()}}}</h2>
        <span>{{'multiples_possible' | translate}}</span>
      </div>

      @for (question of currentPageQuestions(); track question.station.id; let i = $index) {
        <div class="question">
          <label class="question-text">
            <input type="checkbox"
              [checked]="isSituationSelected(question.station.id)"
              (change)="toggleSituation($event.target.checked , question, page())">
            {{profileForm.name().value()}} {{getTextFromStation(question.station.id) | async}}
          </label>
        </div>
    }

    <div class="question">
      <label class="question-text">
        <input
          type="checkbox"
          mat-checkbox
          [checked]="profileForm.noMatching().value()"
          (change)="toggleCurrentPageSituations(page())">
        {{'no_matching_selection' | translate}}
      </label>
    </div>
  }

  <div class="container-button-center ">
    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      [disabled]="!profileForm.acceptTerms().value() || !profileForm.readInstructions().value()"
      (click)="goToNext()">
      @if (page() === -1) {
        {{'start_checkin' | translate}}
      } @else {
        @if (isLastSlide()) {
          {{'finish' | translate}}
        } @else {
          {{'continue' | translate}}
        }
      }
    </button>

    @if (page() === -1) {
      <button  matButton="filled"
        class="button-rounded-center" color="accent"
        [disabled]="!profileForm.acceptTerms().value()"
        (click)="skipCheckin()">
        @if (page() === -1) {
          {{'skip' | translate}}
        }
      </button>
    }
  </div>

  <div class="container-dialog container-dialog-main-goal"
    #popoverMainGoalDialog
    popover="manual">
    @let goals = overallSelectedGoals();
    <h2>{{'goal_accept_title' | translate}}</h2>
    @if (goals?.length === 1) {
      <p>{{'goal_accept_text' | translate}}</p>
    } @else {
      <p>{{'goal_select_text' | translate}}</p>
    }

    @for (goal of goals; track $index) {
      <label>
        <input type="radio" [value]="goal" [formField]="profileForm.goal" />
        {{goal | translate}}
      </label>
    }

     <div class="container-button-center ">
      <button
        matButton="filled"
        class="button-rounded-center"
        [disabled]="this.profileForm.goal().value() === GoalGeneral"
        color="accent"
        (click)="onClickContinueSelectMainGoal()">
        {{'goal_accept_title' | translate}}
      </button>
    </div>
  </div>
</form>

<div class="container-dialog"
  #popoverDialog
  popover="manual">

  <h2>{{'no_selection_made' | translate}}</h2>
  <p>{{'no_selection_made_text_1' | translate}}</p>
  <p>{{'no_selection_made_text_2' | translate}}</p>
  <p>{{'no_selection_made_text_3' | translate}}</p>

  <div class="container-button-center">
    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      [disabled]="!profileForm.acceptTerms().value()"
      (click)="onDialogContinue()">
      {{'no_selection_continue' | translate}}
      </button>

    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      [disabled]="!profileForm.acceptTerms().value()"
      (click)="onDialogBack()">
      {{'no_selection_back' | translate}}
      </button>
  </div>
</div>
